import { useMutation } from "@tanstack/react-query";

import { createOrder } from "../services/payments";

export function useCreateOrder() {

    return useMutation({

        mutationFn: createOrder,

    });

}